<template>
    <div class="quiz-game-home">
        <div class="title"><span v-if="schoolVers || isHtcc">{{ $t('HTwbActKitHome.campusPrefix') }}</span>{{ $t('HTwbActKitHome.title') }}</div>
        <div class="game-menu">
            <div class="game-row">
                <div class="game-item">
                    <div class="game-card" >
                        <img @click="navigateToGame('/ht-molegame-play')" :src="require('@/assets/HTwbActAssets/home/cover-molegame.webp')" alt="Mole Game">
                        <div class="game-name">{{ $t('HTwbActKitHome.moleGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('moleGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
                <div class="game-item">
                    <div class="game-card" >
                        <img @click="navigateToGame('/ht-pvpgame-play')" :src="require('@/assets/HTwbActAssets/home/cover-pvpgame.webp')" alt="PVP Game">
                        <div class="game-name">{{ $t('HTwbActKitHome.pvpGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('pvpGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
                <div class="game-item">
                    <div class="game-card" >
                        <img @click="navigateToGame('/ht-pvp-tfgame-play')" :src="require('@/assets/HTwbActAssets/home/cover-tfgame.webp')" alt="TF Game">
                        <div class="game-name">{{ $t('HTwbActKitHome.tfGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('tfGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
            </div>
            <div class="game-row">
                <!-- 挑人轉盤 - iframe 環境隱藏 -->
                <div class="game-item" v-if="!isInIframe">
                    <div class="game-card" >
                        <img @click="navigateToGame('/ht-pickgame-play')" :src="require('@/assets/HTwbActAssets/home/cover-pick.webp')" alt="Pick Game">
                        <div class="game-name">{{ $t('HTwbActKitHome.pickGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('pickGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
                <!-- 戳戳樂 - iframe 環境隱藏 -->
                <div class="game-item" v-if="!isInIframe">
                    <div class="game-card" >
                        <img @click="navigateToGame('/ht-punchboard-play')" :src="require('@/assets/HTwbActAssets/home/cover-punchboard.webp')" alt="PunchBoard Game">
                        <div class="game-name">{{ $t('HTwbActKitHome.punchBoardGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('punchBoardGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
                <!-- 更多遊戲管理 - 需校園版授權（非校園版顯示但不可進入） -->
                <div class="game-item">
                    <div class="game-card" @click="handleVipGameClick('moreManagement')">
                        <img :src="require('@/assets/HTwbActAssets/home/cover-gamesetting.webp')" alt="More Game Management">
                        <div class="vip-badge" v-if="!isHtcc">
                            <svg-icon icon-class="crown" />
                        </div>
                        <div class="game-name">{{ $t('HTwbActKitHome.moreManagement') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('moreManagement')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
            </div>
            <!-- 詞彙貪食蛇、迷宮 - iframe 環境隱藏整行 -->
            <div class="game-row" v-if="!isInIframe">
                <div class="game-item">
                    <div class="game-card" >
                        <img @click="handleVipGameClick('snakeGame')" :src="require('@/assets/HTwbActAssets/home/cover-snakegame.webp')" alt="Snake Game">
                        <div class="vip-badge">
                            <svg-icon icon-class="crown" />
                        </div>
                        <div class="game-name">{{ $t('HTwbActKitHome.snakeGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('snakeGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
                <div class="game-item">
                    <div class="game-card" >
                        <img @click="handleVipGameClick('mazeGame')" :src="require('@/assets/HTwbActAssets/home/cover-mazegame.webp')" alt="Maze Game">
                        <div class="vip-badge">
                            <svg-icon icon-class="crown" />
                        </div>
                        <div class="game-name">{{ $t('HTwbActKitHome.mazeGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('mazeGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
            </div>
        </div>

        <!-- 遊戲說明彈出視窗 -->
        <div class="popup-overlay" v-if="showPopup" @click="closePopup"></div>
        <div class="game-info-popup" v-if="showPopup">
            <div class="popup-header">
                <h2>{{ $t(`HTwbActKitHome.${currentGame}Title`) }}</h2>
                <div class="close-btn" @click="closePopup">
                    <svg-icon icon-class="close" />
                </div>
            </div>
            <div class="popup-content">
                <div class="game-image">
                    <img :src="require(`@/assets/HTwbActAssets/home/cover-${currentGameKey}.webp`)" :alt="$t(`HTwbActKitHome.${currentGame}Title`)">
                </div>
                <div class="game-description">
                    <p>{{ $t(`HTwbActKitHome.${currentGame}Desc`) }}</p>
                </div>
                <div class="popup-footer">
                    <button class="play-btn" @click="playCurrentGame">
                        {{ currentGame === 'moreManagement' ? $t('HTwbActKitHome.enterManagement') : $t('HTwbActKitHome.play') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import jwt_decode from 'jwt-decode';
import SvgIcon from '@/components/SvgIcon.vue';
import { Message } from 'view-ui-plus';
import { useI18n } from 'vue-i18n';

const router = useRouter();
const { t } = useI18n();

// 狀態變數
const showPopup = ref(false);
const currentGame = ref('');
const currentGameKey = ref('');
const schoolVers = ref(false); // 校園版授權狀態
const isHtcc = ref(sessionStorage.getItem('jumpFrom') === 'HTCC'); // 是否為 HTCC 環境

// 檢查是否在 iframe 環境中
const isInIframe = computed(() => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true; // 如果拋出異常，說明在跨域 iframe 中
    }
});
const gameRoutes = {
    pvpGame: '/ht-pvpgame-play',
    moleGame: '/ht-molegame-play',
    tfGame: '/ht-pvp-tfgame-play',
    pickGame: '/ht-pickgame-play',
    punchBoardGame: '/ht-punchboard-play',
    moreManagement: '/game-act-manager',
    snakeGame: '/ht-snakegame-play',
    mazeGame: '/ht-mazegame-play'
};

// VIP 遊戲列表（需要校園版授權）
const vipGames = ['snakeGame', 'mazeGame', 'moreManagement'];

// 方法
// 檢查是否需要校園版授權
const checkSchoolVersion = (gameType) => {
    if (vipGames.includes(gameType) && !schoolVers.value) {
        Message.warning({
            content: t('HTwbActKitHome.schoolVersionWarning'),
            duration: 3
        });
        return false;
    }
    return true;
};

const navigateToGame = (route) => {
    router.push(route);
};

// 處理 VIP 遊戲點擊（需校園版授權才可進入）
const handleVipGameClick = (gameType) => {
    if (checkSchoolVersion(gameType)) {
        navigateToGame(gameRoutes[gameType]);
    }
};


const showGameInfo = (gameType) => {
    currentGame.value = gameType;
    currentGameKey.value = gameType === 'pvpGame' ? 'pvpgame' :
                       gameType === 'moleGame' ? 'molegame' :
                       gameType === 'tfGame' ? 'tfgame' :
                       gameType === 'pickGame' ? 'pick' :
                       gameType === 'punchBoardGame' ? 'punchboard' :
                       gameType === 'snakeGame' ? 'snakegame' :
                       gameType === 'mazeGame' ? 'mazegame' : 'gamesetting';
    showPopup.value = true;
};

const closePopup = () => {
    showPopup.value = false;
};

const playCurrentGame = () => {
    if (currentGame.value && gameRoutes[currentGame.value]) {
        // 檢查校園版授權
        if (!checkSchoolVersion(currentGame.value)) {
            return;
        }
        navigateToGame(gameRoutes[currentGame.value]);
        closePopup();
    }
};

// HiTeachCC Origin 白名單
const HITEACHCC_ALLOWED_ORIGINS = [
    // Global 站點
    'https://hiteachcc.teammodel.net',
    'https://hiteachcc-rc.teammodel.net',
    'https://hiteachcc-test.teammodel.net',
    // CN 站點
    'https://hiteachcc.teammodel.cn',
    'https://hiteachcc-rc.teammodel.cn',
    'https://hiteachcc-test.teammodel.cn',
    // 本地開發
    'http://localhost:8080',
    'http://localhost:5173'
];

// 通信工具類
const MessageBridge = {
    // 環境類型
    ENV: {
        WEBVIEW: 'webview',
        WEB: 'web'
    },
    // 當前環境
    currentEnv: 'webview',
    // 初始化
    init() {
        this.currentEnv = window?.chrome?.webview ? this.ENV.WEBVIEW : this.ENV.WEB;
        return this;
    },
    // 發送消息
    postMessage(data, origin = '*') {
        if (this.currentEnv === this.ENV.WEBVIEW) {
            window?.chrome?.webview.postMessage(data);
        } else {
            window.postMessage(data, origin);
        }
    },
    // 發送消息給父視窗（iframe 專用）
    postMessageToParent(data, origin = '*') {
        try {
            if (window.parent && window.parent !== window) {
                window.parent.postMessage(data, origin);
            }
        } catch (e) {
            console.warn('[MessageBridge] postMessageToParent 失敗:', e);
        }
    },
    // 添加消息監聽器
    addEventListener(callback) {
        if (this.currentEnv === this.ENV.WEBVIEW) {
            window?.chrome?.webview.addEventListener('message', event => {
                callback(event);
            });
        } else {
            window.addEventListener('message', event => {
                callback(event);
            });
        }
    }
};

// 初始化消息橋接器
const messageBridge = MessageBridge.init();

// 設定使用者驗證資料
const setupUserAuth = (authData) => {
    try {
        console.log('設定使用者驗證資料:', authData);

        // 儲存登入資料到 localStorage（使用標準鍵值）
        if (authData.id_Token) {
            localStorage.setItem('id_token', authData.id_Token);
        }
        if (authData.access_Token) {
            localStorage.setItem('access_token', authData.access_Token);
        }
        if (authData.expires_in) {
            localStorage.setItem('expires_in', authData.expires_in);
        }
        if (authData?.hostSoftwareVersion) {
            sessionStorage.setItem('HiTeach_Version', authData.hostSoftwareVersion);
            console.log('HiTeach 版本:', authData.hostSoftwareVersion);
        }

        // 儲存 HiTeach 名單（如果有）
        if (authData.memberList && Array.isArray(authData.memberList)) {
            sessionStorage.setItem('ht_memberList', JSON.stringify(authData.memberList));
            console.log('儲存 HiTeach 名單 (', authData.memberList.length, '位學生):', authData.memberList);
        }

        // 儲存校園版授權狀態
        // 🔧 如果在 iframe 環境中，保持校園版權益為 true，不被外部覆蓋
        if (authData.school_vers !== undefined) {
            if (isInIframe.value) {
                // iframe 模式：強制保持校園版為 true
                schoolVers.value = true;
                localStorage.setItem('school_vers', 'true');
                console.log('[iframe 模式] 保持校園版授權為 true（忽略外部傳入值）');
            } else {
                // 非 iframe 模式：使用外部傳入的值
                schoolVers.value = authData.school_vers;
                localStorage.setItem('school_vers', String(authData.school_vers));
                console.log('校園版授權狀態:', authData.school_vers);
            }
        }

        // 如果有 id_Token，解碼並儲存 profile
        if (authData.id_Token) {
            try {
                const decoded = jwt_decode(authData.id_Token);
                const profile = {
                    name: decoded.name || '使用者',
                    id: authData.login_Id,
                    picture: decoded.picture || ''
                };
                localStorage.setItem('profile', JSON.stringify(profile));
            } catch (decodeError) {
                console.error('解碼 id_token 失敗:', decodeError);
            }
        }

        // 設定 jumpFrom 標記
        sessionStorage.setItem('jumpFrom', 'HT');

        console.log('驗證資料已儲存完成');
    } catch (error) {
        console.error('設定使用者驗證時發生錯誤:', error);
    }
};

// 設定使用者驗證資料（來自 HiTeachCC.Auth）
const setupHiTeachCCAuth = (authData) => {
    try {
        console.log('[HTwbActKitHome] 設定 HiTeachCC 驗證資料:', authData);

        const { accessToken, idToken, expiresIn } = authData;

        // 儲存 Token 到 localStorage
        if (accessToken) {
            localStorage.setItem('access_token', accessToken);
        }
        if (idToken) {
            localStorage.setItem('id_token', idToken);
        }
        if (expiresIn) {
            localStorage.setItem('expires_in', expiresIn.toString());
        }

        // 解碼 JWT 取得用戶資訊並儲存 Profile
        if (idToken) {
            try {
                const decoded = jwt_decode(idToken);
                const profileData = {
                    id: decoded.sub,
                    teammodelId: decoded.sub,
                    name: decoded.name || '使用者',
                    picture: decoded.picture || ''
                };
                localStorage.setItem('profile', JSON.stringify(profileData));
                console.log('[HTwbActKitHome] Profile 已儲存:', profileData);
            } catch (decodeError) {
                console.error('[HTwbActKitHome] 解碼 idToken 失敗:', decodeError);
            }
        }

        // 設定 jumpFrom 標記（標記來自 HiTeachCC）
        sessionStorage.setItem('jumpFrom', 'HTCC');
        isHtcc.value = true;

        // iframe 模式下自動啟用校園版權益
        schoolVers.value = true;
        localStorage.setItem('school_vers', 'true');

        console.log('[HTwbActKitHome] HiTeachCC 驗證資料已儲存完成');
    } catch (error) {
        console.error('[HTwbActKitHome] 設定 HiTeachCC 驗證時發生錯誤:', error);
    }
};

onMounted(() => {
    // 🔧 優先從 localStorage 讀取校園版權益狀態（處理按上一頁返回的情況）
    const storedSchoolVers = localStorage.getItem('school_vers');
    if (storedSchoolVers !== null && storedSchoolVers === 'true') {
        schoolVers.value = true;
        console.log('[恢復] 從 localStorage 讀取校園版權益: true');
    } else {
        console.log('[初始化] localStorage 無校園版權益記錄，等待 Init.GameHome 訊息');
    }

    // 🔧 如果在 iframe 環境中，預設啟用校園版權益
    if (isInIframe.value) {
        schoolVers.value = true;
        localStorage.setItem('school_vers', 'true');
        console.log('[iframe 模式] 自動啟用校園版權益，貪食蛇和迷宮遊戲可用');

        // 發送 Ready 訊息給父視窗，通知 HiTeachCC 可以發送登入資訊
        setTimeout(() => {
            messageBridge.postMessageToParent({ action: 'GamePage.Ready', gameName: 'HTwbActKitHome' }, '*');
            console.log('[iframe 模式] 已發送 GamePage.Ready 給父視窗');
        }, 100);
    }

    // messageBridge.postMessage({ action: 'GoTo.Game', data: { page: 'molegame' } });
    // 添加消息監聽器
    messageBridge.addEventListener(event => {
        const msg = event.data;
        console.log('[HTwbActKitHome] 收到訊息:', msg);

        if (msg.action === 'GoTo.Game') {
            const pageToGameType = {
                'pvpgame': 'pvpGame',
                'molegame': 'moleGame',
                'tfgame': 'tfGame',
                'pickgame': 'pickGame',
                'punchboard': 'punchBoardGame',
                'snakegame': 'snakeGame',
                'mazegame': 'mazeGame'
            };

            const gameType = pageToGameType[msg?.data?.page];

            if (gameType) {
                // 檢查是否為 VIP 遊戲且需要授權
                if (vipGames.includes(gameType) && !checkSchoolVersion(gameType)) {
                    return;
                }
                navigateToGame(gameRoutes[gameType]);
            }
        }
        else if (msg.action === 'Init.GameHome') {
            setupUserAuth(msg.data);
        }
        // 監聽 HiTeachCC.Auth 訊息（來自 HiTeachCC iframe）
        else if (msg.action === 'HiTeachCC.Auth' || msg.action === 'HiTeachCC.TokenRefresh') {
            // Origin 白名單驗證
            if (event.origin && !HITEACHCC_ALLOWED_ORIGINS.includes(event.origin)) {
                console.warn('[HTwbActKitHome] 拒絕來自未授權來源的 HiTeachCC 訊息:', event.origin);
                return;
            }

            const isInitialAuth = msg.action === 'HiTeachCC.Auth';
            console.log(`[HTwbActKitHome] 收到 ${isInitialAuth ? 'HiTeachCC.Auth' : 'HiTeachCC.TokenRefresh'} 訊息`);
            setupHiTeachCCAuth(msg);
        }
    });
});
</script>

<style lang="less" scoped>
.quiz-game-home {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
    position: relative;

    .title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 30px;
        color: #333;
        text-align: center;
    }

    .game-menu {
        width: 100%;
        max-width: 1200px;

        .game-row {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 30px;
            margin-bottom: 30px;
        }

        .game-item {
            position: relative;
            width: 300px;
            transition: transform 0.3s ease;

            &:hover {
                transform: translateY(-5px);
            }

            .game-card {
                cursor: pointer;
                background-color: white;
                border-radius: 15px;
                overflow: hidden;
                box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
                transition: all 0.3s ease;
                position: relative;

                &:hover {
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
                }

                img {
                    width: 100%;
                    height: 200px;
                    object-fit: cover;
                    object-position: center;
                }

                .vip-badge {
                    position: absolute;
                    top: 150px;
                    right: 15px;
                    width: 40px;
                    height: 40px;
                    background: rgba(0, 0, 0, 0.7);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 2;

                    svg {
                        width: 28px;
                        height: 28px;
                        color: #FFD700;
                    }
                }

                .game-name {
                    padding: 15px;
                    font-size: 18px;
                    font-weight: bold;
                    text-align: center;
                    color: #333;
                }
            }

            .info-icon {
                position: absolute;
                bottom: 15px;
                left: 15px;
               
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
              
                z-index: 2;
                transition: all 0.2s ease;

                &:hover {
                    transform: scale(1.1);
                    background-color: #fff;
                }

                svg {
                    width: 30px;
                    height: 30px;
                    color: gray;
                }
            }
        }
    }

    // 彈出視窗樣式
    .popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 100;
    }

    .game-info-popup {
        position: fixed;
        top: 10vh;
        left: 50%;
        transform: translateX(-50%);
        width: 90%;
        max-width: 500px;
        background-color: white;
        border-radius: 15px;
        box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
        z-index: 101;
        overflow: hidden;

        .popup-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding:0px 20px;
            font-weight: bold;
            border-bottom: 1px solid #eee;

            h2 {
                margin: 0;
                font-size: 20px;
                color: #333;
            }

            .close-btn {
                cursor: pointer;
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all 0.2s ease;
                font-size: 24px;

                svg {
                    font-size: 24px;
                    line-height: 1;
                    color: #555;
                }
                &:hover {
                    svg {
                        font-size: 26px;
                    }
                }
            }
        }

        .popup-content {
            padding: 20px;

            .game-image {
                width: 100%;
                max-height: 300px;
                overflow: hidden;
                margin-bottom: 20px;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: auto;
                    border-radius: 10px;
                    max-width: 100%;
                    height: auto;
                    max-height: 300px;
                    object-fit: contain;
                }
            }

            .game-description {
                margin-bottom: 20px;

                p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                    white-space: pre-line;
                }
            }

            .popup-footer {
                display: flex;
                justify-content: center;

                .play-btn {
                    padding: 10px 30px;
                    background-color: #4CAF50;
                    color: white;
                    border: none;
                    border-radius: 30px;
                    font-size: 16px;
                    font-weight: bold;
                    cursor: pointer;
                    transition: all 0.2s ease;

                    &:hover {
                        background-color: #45a049;
                        transform: translateY(-2px);
                    }
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .quiz-game-home {
        .game-menu {
            .game-item {
                width: 100%;
                max-width: 300px;
            }
        }

        .game-info-popup {
            width: 95%;
            max-height: 90vh;
            overflow-y: auto;
        }
    }
}
</style>